import { render, staticRenderFns } from "./LightBoxOverOneYear.vue?vue&type=template&id=6fbd5725&"
import script from "./LightBoxOverOneYear?vue&type=script&lang=ts&"
export * from "./LightBoxOverOneYear?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports